module.exports = __webpack_public_path__ + "img/prision_preventiva.37acdd38.png";